export const cdnImage = (string) =>
  `https://cdn.canopytax.com/images/${string}`;
